import { create } from 'zustand';
import {doc, getDoc, setDoc} from "firebase/firestore";
import {db} from "../config/firebase/firebase";
import {message} from "antd";

interface CvBalanceState {
    cvSent: number | null;
    sendsInPackage: number | null;
    expirationDate: string | null;
    expirationDateRaw: any | null;
    isEnabled: boolean;
    packageType: string | null;
    fastTrackEnabled: boolean;
    isAllowed:boolean;
    isLoading: boolean;
    fetchBalance: (email: string) => Promise<void>;
    updateBalance: (newBalance: number) => void;
    handleToggleEnabled: (checked: boolean, currentUser: string | null | undefined) => Promise<void>;
}

export const useCvBalanceStore = create<CvBalanceState>((set, get) => ({
    cvSent: null,
    sendsInPackage: null,
    expirationDate: null,
    expirationDateRaw: null,
    isEnabled: false,
    packageType: null,
    fastTrackEnabled: false,
    isAllowed: true,
    isLoading: false,

    fetchBalance: async (email: string) => {
        set({ isLoading: true });

        try {
            const userEmail = email;

            // Fetch token data
            const tokenRef = doc(db, `users/${userEmail}/bas.token/1`);
            const tokenDoc = await getDoc(tokenRef);

            if (tokenDoc.exists()) {
                const data = tokenDoc.data();


                set({
                    cvSent: data.cvSent ?? null,
                    sendsInPackage: data.sendsInPackage ?? null,
                    expirationDateRaw: data.expirationDate,
                    expirationDate: data.expirationDate ? data.expirationDate.toDate() : null,
                    isEnabled: data.isEnabled ?? false,
                    packageType: data.packageType,
                    fastTrackEnabled: data.fastTrackEnabled ?? false,
                    isLoading: false
                });
            }

            // Fetch isAllowed field
            const userRef = doc(db, `users/${userEmail}`);
            const userDoc = await getDoc(userRef);

            if (userDoc.exists()) {
                set({ isAllowed: userDoc.data().isAllowed, isLoading: false });
            } else {
                set({ isAllowed: false, isLoading: false });
            }
        } catch (err) {
            console.error("Error fetching data: ", err);
        } finally {
            set({ isLoading: false });
        }
    },

    updateBalance: (newBalance: number) => {
        //set({ balance: newBalance });
    },

    handleToggleEnabled: async (checked: boolean, email: string | null | undefined) => {
        if (!get().isAllowed) {
            message.warning('Please top up your balance to start using the cv automation');
            return;
        }

        if (!email) {
            message.error('User email is not available. Please log in again.');
            return;
        }

        const cvSent = get().cvSent;
        const sendsInPackage = get().sendsInPackage;
        if(cvSent >= sendsInPackage) {
            message.error('Balance is out of limit. Please top up');
            return;
        }

        const previousState = get().isEnabled;
        set({ isEnabled: checked });

        try {
            const userEmail = email;
            const docRef = doc(db, `users/${userEmail}/bas.token/1`);
            await setDoc(docRef, { isEnabled: checked }, { merge: true });
            message.success(`Cv automation ${checked ? 'enabled' : 'disabled'}`);
        } catch (error) {
            console.error('Error updating isEnabled: ', error);
            message.error('Failed to update feature status.');
            set({ isEnabled: previousState });
        }
    },
}));
